<template>
  <div>
    <div class="box">
      <div class="tip-box mb-30">
        <div class="tips">当前培训班</div>
      </div>
      <div class="flex-wrap mb-50" style="gap: 24px;">
        <div v-for="item in current" class="course-item" @click="handleDetail(item.id)">
          <img :src="item.url ? item.url : require('@/assets/images/defaultImg.jpg')" alt="">
          <div class="coure-info">
            <div class="course-title two-row">
              {{ item.title }}
            </div>
            <div class="course-desc">培训时间：{{ item.startTime.slice(0, -9).replaceAll('-', '.') }}—{{ item.endTime.slice(0, -9).replaceAll('-', '.') }}</div>
            <div class="course-desc mtb-10">学 时：<span style="color: #EA0000;">{{ item.hours }}</span></div>
            <div class="course-desc one-row">主办单位：{{ item.receiveOrgName }}</div>
          </div>
          <div class="status-tag" :class="getStatusClass(item)">{{ getStatusText(item) }}</div>
        </div>
      </div>
      <div class="tip-box tip-box2 mb-30">
        <div class="tips tips2">历史培训班</div>
        <select v-model="currentYear" @change="handleChange">
          <!-- <option value="">请选择年度</option> -->
          <option :value="item" v-for="item in years">{{ item }}</option>
        </select>
      </div>
      <div class="flex-wrap" style="gap: 24px;">
        <div v-for="item in history" class="course-item" @click="handleDetail(item.id)">
          <img :src="item.url ? item.url : require('@/assets/images/defaultImg.jpg')" alt="">
          <div class="coure-info">
            <div class="course-title two-row">
              {{ item.title }}
            </div>
            <div class="course-desc">培训时间：{{ item.startTime.slice(0, -9).replaceAll('-', '.') }}—{{ item.endTime.slice(0, -9).replaceAll('-', '.') }}</div>
            <div class="course-desc mtb-10">学 时：<span style="color: #EA0000;">{{ item.hours }}</span></div>
            <div class="course-desc one-row">主办单位：{{ item.receiveOrgName }}</div>
          </div>
          <div class="status-tag" :class="getStatusClass(item)">{{ getStatusText(item) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getXmList, getXmHistory } from '@/api/index';
export default {
  data() {
    return {
      current: [],
      history: [],
      years: [],
      currentYear: ''
    };
  },
  created() {
    // this.getList()
    getXmList().then(res => {
      this.current = res.current;
      this.history = res.history;
      this.years = res.years;
      this.currentYear = res.currentYear;
    })
  },
  methods: {
    handleDetail(id) {
      this.$router.push({ path: '/myTrain/detail?id=' + id });
    },
    handleChange() {
      console.log(this.currentYear);
      getXmHistory({ years: this.currentYear }).then(res => {
        this.history = res;
      })
    },
    getStatusClass(item) {
      const now = new Date().getTime();
      const startTime = new Date(item.startTime).getTime();
      const endTime = new Date(item.endTime).getTime();
      
      if (now < startTime) {
        return 'status-not-started';
      } else if (now >= startTime && now <= endTime) {
        return 'status-in-progress';
      } else {
        return 'status-ended';
      }
    },
    getStatusText(item) {
      const now = new Date().getTime();
      const startTime = new Date(item.startTime).getTime();
      const endTime = new Date(item.endTime).getTime();
      
      if (now < startTime) {
        return '未开始';
      } else if (now >= startTime && now <= endTime) {
        return '进行中';
      } else {
        return '已结束';
      }
    },
  },
};
</script>

<style scoped lang="scss">
.box {
  background-color: #fff;
  padding: 24px 24px 50px 24px;
}

.tip-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #E4381D;

  .tips {
    position: relative;
    padding: 0 18px 0 10px;
    background: linear-gradient( 270deg, #E4381D 0%, #D81D10 100%);
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    line-height: 28px;

    &::before {
      content: '';
      position: absolute;
      z-index: 22;
      width: 0;
      height: 0;
      right: 0;
      border-right: 12px solid #fff; /* 高度 */
      border-bottom: 28px solid transparent; /* 透明的上边框 */
    }

    &::after {
      content: '';
      position: absolute;
      z-index: 22;
      right: -10px;
      width: 10px;
      height: 28px;
      background: linear-gradient( 147deg, #F59A23 0%, #FF901A 98%);
      transform: skew(26deg);
    }
  }
}

.tip-box2 {
  border-bottom: 1px solid #AAAAAA;

  .tips2 {
    background: #767676;

    &::after {
      background: #AAAAAA;
    }
  }
}

.course-item {
  position: relative;
  width: calc((100% - 72px) / 4);
  border-radius: 5px 5px 5px 5px;
  border: 1px solid #EEEEEE;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease;
    transform: scale(1.05);
  }

  img {
    display: block;
    width: 100%;
    height: 152px;
    border-radius: 5px;
  }

  .coure-info {
    padding: 10px 10px 15px 10px;

    .course-title {
      font-size: 16px;
      color: #1A1A1A;
      line-height: 24px;
      margin-bottom: 12px;
    }

    .course-desc { 
      font-size: 14px;
      color: #767676;
      line-height: 14px;
    }

    .course-tip {
      width: 67px;
      line-height: 22px;
      background: #EEEEEE;
      border-radius: 4px 4px 4px 4px;

      font-size: 12px;
      text-align: center;
    }
  }
}

select {
  margin-right: 6px;
  padding: 0 10px;
  height: 22px;
  border-radius: 5px;
  background: #FFFFFF;
  border: 1px solid #AAAAAA;
  color: #767676;
  font-size: 13px;
  line-height: 14px;
}

.status-tag {
  padding: 6px 9px;
  border-radius: 0px 5px 0px 15px;
  border-left: 1px solid #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 14px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
}

.status-not-started {
  background: linear-gradient( 180deg, #0CB8FF 0%, #0B92FF 100%);
}

.status-in-progress {
  background: linear-gradient( 180deg, #FFAD0D 0%, #FF930C 100%);
}

.status-ended {
  background: #9C9C9C;
}
</style>